import { render, staticRenderFns } from "./sa-organization-list.html?vue&type=template&id=8dcdfd24&scoped=true&external"
import script from "./sa-organization-list.js?vue&type=script&lang=js&external"
export * from "./sa-organization-list.js?vue&type=script&lang=js&external"
import style0 from "./sa-organization-list.scss?vue&type=style&index=0&id=8dcdfd24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcdfd24",
  null
  
)

export default component.exports